import { render, staticRenderFns } from "./ManageStreams.vue?vue&type=template&id=08a30b65&"
import script from "./ManageStreams.vue?vue&type=script&lang=js&"
export * from "./ManageStreams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports